import '../../css/base.css';

const Knoydart = () => {

  return (
    <div>
      <h2 className="walks-section-heading">Knoydart</h2>
      <p className="walk-text">The peninsula opposite the cottage on the far side of Loch Hourn is Knoydart.  It is one of the most remote places in Scotland with no access by road. Access is by a long walk from Kinlochhourn
                                or by sea from Arnisdale to Barrisdale Bay.  The mountain opposite the cottage is the 1020m Ladhar Bheinn, also known as Larven.
                                It is a remote place which is a serious undertaking due to its distance from civilisation and the fact that there is not a path for significant portions of 
                                the walk.  For those with the skills to take it on it is an unforgettable day out on the hills.  See the view from Larven below.
      </p>                                            
    </div>
  );
}

export default Knoydart
